'use client';

import { c as _c } from "react/compiler-runtime";
import { Dictionary } from '@/src/lib/dictionary/types';
import React from 'react';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
export default function UserProfileButtonLoggedOut(t0) {
  const $ = _c(6);
  const {
    dict,
    lang,
    returnTo
  } = t0;
  const t1 = `/auth/login?ui_locales=${lang}${returnTo ? `&returnTo=${returnTo}` : ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="w-12 h-12 inline-flex justify-center items-center"><Icon name={IconName.PERSON} className="text-primary" data-testid="button-initials" /></span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== dict.general.loginButton) {
    t3 = <span className="pr-5 pl-1 inline-flex justify-center items-center font-semibold" data-testid="button-text">{dict.general.loginButton}</span>;
    $[1] = dict.general.loginButton;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <a className="w-fit bg-black text-white flex flex-row items-stretch h-full no-underline! uppercase" href={t1} data-testid="user-profile-button">{t2}{t3}</a>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}